import { getConfigValue } from '@zonofi/common';
import moment from 'moment';

export const onClickBackToWhatsapp = ({
  whatsappPhoneNo,
  workspaceId,
  isSimulation,
  sendEventToParent,
}: {
  whatsappPhoneNo?: string;
  workspaceId?: string;
  isSimulation?: boolean;
  sendEventToParent?: () => void;
}) => {
  if (isSimulation) {
    sendEventToParent?.();
    return;
  }
  if (whatsappPhoneNo && whatsappPhoneNo?.trim()) {
    window.location.href = `https://wa.me/${whatsappPhoneNo}`;
  } else if (workspaceId === 'c9bedd72-85d7-41c4-8c62-e33ffc926966') {
    window.location.href = getConfigValue('WAPP_REDIRECT_BJ_GROUP');
  } else {
    window.location.href = getConfigValue('WAPP_REDIRECT');
  }
};
export const getBackToWhatsappLink = ({
  whatsappPhoneNo,
  workspaceId,
}: {
  whatsappPhoneNo?: string;
  workspaceId?: string;
}) => {
  if (whatsappPhoneNo && whatsappPhoneNo?.trim()) {
    return `https://wa.me/${whatsappPhoneNo}`;
  } else if (workspaceId === 'c9bedd72-85d7-41c4-8c62-e33ffc926966') {
    return getConfigValue('WAPP_REDIRECT_BJ_GROUP');
  } else {
    return getConfigValue('WAPP_REDIRECT');
  }
};

export const onClickRaiseRequest = ({
  title,
  whatsappPhoneNo,
  workspaceId,
}: {
  title?: string;
  whatsappPhoneNo?: string;
  workspaceId?: string;
}) => {
  const encodedMessage = encodeURIComponent(
    `\u200EI need more information about ${title}`
  );
  if (whatsappPhoneNo && whatsappPhoneNo?.trim()) {
    window.location.href = `https://wa.me/${whatsappPhoneNo}?text=${encodedMessage}`;
  } else if (workspaceId === 'c9bedd72-85d7-41c4-8c62-e33ffc926966') {
    window.location.href =
      getConfigValue('WAPP_REDIRECT_BJ_GROUP') + '?text=' + encodedMessage;
  } else {
    window.location.href =
      getConfigValue('WAPP_REDIRECT') + '?text=' + encodedMessage;
  }
};

export function isYesterday(startDate: Date, endDate: Date): boolean {
  const start = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  return start.isSame(yesterday) && end.isSame(yesterday);
}
export function isToday(startDate: Date, endDate: Date): boolean {
  const start = moment(startDate.toISOString()).startOf('day');
  const end = moment(endDate.toISOString()).startOf('day');
  const today = moment().startOf('day');

  return start.isSame(today) && end.isSame(today);
}
